import BusinessSettingsModal from './BusinessSettingsModal';

export default BusinessSettingsModal;
